import React, { Component } from 'react';

import { connect } from 'react-redux';

import _ from 'lodash';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import ConfirmButton from '../../components/ConfirmButton';
import FileUploadInput from '../Global/FileUploadInput';

import validator from '../../helpers/validator';

import * as UiActions from '../../actions/uiActions';

import classes from './AgentNetworkPanel.module.css';

class BacNetEthernetPanel extends Component {
    state = {
        fileImport:   null,
        fileName:     null,
        formIsValid:  false,
        formControls: {
            bacNetDeviceId: {
                value:           '',
                placeholder:     'BAS Agent BACnet Device ID',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {
                    isRequired: true,
                    isNumeric:  true
                }
            },
            apduTimeout: {
                value:           10000,
                placeholder:     'APDU Timeout (ms)',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {
                    isNumeric: true,
                    minLength: 4
                }
            },
            apduSegmentTimeout: {
                value:           10000,
                placeholder:     'APDU Segment Timeout (ms)',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {
                    isNumeric: true,
                    minLength: 4
                }
            },
            apduRetries: {
                value:           3,
                placeholder:     'APDU Retries',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {
                    isNumeric: true,
                    minLength: 1
                }
            },
            whoisTimeout: {
                value:           30,
                placeholder:     'WHOIS Timeout (s)',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {
                    isNumeric: true,
                    minValue:  10
                }
            },
            readQueueSize: {
                value:           10,
                placeholder:     'Read Queue Size',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {
                    isNumeric: true,
                    minLength: 1
                }
            },
            disableReadMultiple: {
                value:           false,
                placeholder:     'Disable Read Multiple',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {

                }
            },
            subnetMask: {
                value:           '255.255.255.0',
                placeholder:     'Subnet Mask',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {
                    isRequired:  true,
                    isIpAddress: true
                }
            }
        }
    }

    componentDidMount() {
        const { agent } = this.props;

        if (agent) {
            const driverConfig = _.find(agent.driverConfiguration, driver => driver.basType === 'BacnetEthernet');

            if (_.isNil(driverConfig)) return;

            const connection = _.get(driverConfig, 'connection', {});

            if (_.isEmpty(connection)) return;

            const updatedControls = {...this.state.formControls};

            updatedControls.apduRetries.value = _.get(connection, 'apdU_Retries', 3);
            updatedControls.apduSegmentTimeout.value = _.get(connection, 'apdU_SegmentTimeout', 10000);
            updatedControls.apduTimeout.value = _.get(connection, 'apdU_Timeout', 10000);
            updatedControls.bacNetDeviceId.value = _.get(connection, 'deviceId', '');
            updatedControls.disableReadMultiple.value = _.get(connection, 'disableReadMultiple', false);
            updatedControls.readQueueSize.value = _.get(connection, 'readQueueSize', 10);
            updatedControls.whoisTimeout.value = _.get(connection, 'whoisTimeout', 30);
            updatedControls.subnetMask.value = _.get(connection, 'subnetMask', '255.255.255.0');

            _.forEach(updatedControls, (value, key) => {
                if (!_.isNil(updatedControls[key]) && !_.isEmpty(updatedControls[key])) {
                    updatedControls[key].valid = true;
                    updatedControls[key].touched = true;
                }
            });

            const gatewayDbFile = _.get(agent.driverConfiguration[0], 'gatewayDBFile', {});
            const fileName = _.get(gatewayDbFile, 'name', null);

            this.setState({
                fileName,
                formControls: updatedControls,
                formIsValid:  true
            });
        }
    }

    componentWillUnmount() {
        this.props.clearErrors();
    }

    handleValidation = event => {
        const validatedState = validator(this.state, event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }


    updateControls = (update, event) => {
        const { name } = event.target;
        const updatedControls = { ...this.state.formControls };

        updatedControls[name].value = update;

        this.setState({
            formControls: updatedControls
        });
    }

    handleImport = ({file, fileName}) => {
        this.setState({
            fileImport: file,
            fileName
        });
    };

    handleImportClear = () => {
        this.setState({
            fileImport: null,
            fileName:   null
        });
    }

    handleChange = event => {
        const { value } = event.target;

        this.props.toggleLoading(false);

        this.updateControls(value, event);
    }

    handleCheckbox = event => {
        const { checked } = event.target;

        this.updateControls(checked, event);
    }

    handleSave = () => {
        const { save, agent } = this.props;
        const { formControls } = this.state;
        const payload = {
            basType:    'BacnetEthernet',
            connection: {
                'apdU_Retries':        formControls.apduRetries.value,
                'apdU_SegmentTimeout': formControls.apduSegmentTimeout.value,
                'apdU_Timeout':        formControls.apduTimeout.value,
                deviceId:              formControls.bacNetDeviceId.value,
                disableReadMultiple:   formControls.disableReadMultiple.value,
                host:                  null,
                readQueueSize:         formControls.readQueueSize.value,
                whoisTimeout:          formControls.whoisTimeout.value,
                subnetMask:            formControls.subnetMask.value

            },
            gatewayDBFile: {
                data: this.props.stripFileTypeHeader(this.state.fileImport),
                name: this.state.fileName
            }
        };
        let driverConfig = _.find(agent.driverConfiguration, driver => driver.basType === 'BacnetEthernet');

        if (driverConfig) {
            payload.id = driverConfig.id;
        } else {
            driverConfig = _.find(agent.driverConfiguration, driver => driver.basType === 'NotConfigured');

            if (driverConfig) payload.id = driverConfig.id;
        }

        save(payload);
    }

    render() {
        const { isLoading } = this.props;

        return (
            <div className={classes.NetworkPanel}>
                <div className={classes.formContainer}>
                    <div className={classes.formColumn}>
                        <div className={classes.labelColumn}>
                            <div className={classes.topLabelGroup}>
                                <div className={classes.labelHeader}>
                                    <img src="/assets/images/generalNetworkSettingsIconColor.svg" alt="settings icon" />
                                    <span>BAS Agent BACnet Settings</span>
                                </div>
                                <div className={classes.labelContent}>
                                    The BAS Agent BACnet Settings are for setting up the BAS Agent as a BACnet device on the BACnet network for the BAS you are connecting to.
                                </div>
                            </div>
                            <div>
                                <div className={classes.labelHeader}>
                                    <img src="/assets/images/devicesIconColor.svg" alt="bbmd icon" />
                                    <span>Gateway Database File</span>
                                </div>
                                <div className={classes.labelContent}>
                                    A gateway database file is generated using the Connect Gateway Manager Tool. This file may be required to retrieve data from certain BACnet systems. <a href="https://docs.key2act.io/k2adocs/connect2018/connect-user-guide/scanning-bas-networks" rel="noopener noreferrer" target="_blank">Learn More.</a>
                                </div>
                            </div>
                        </div>
                        <div className={classes.inputColumn}>
                            <div className={`${classes.inputs} ${classes.topInputGroup}`}>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="bacNetDeviceId"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.bacNetDeviceId.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="bacNetDeviceId"
                                        name="bacNetDeviceId"
                                        value={this.state.formControls.bacNetDeviceId.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.bacNetDeviceId.valid &&
                                      this.state.formControls.bacNetDeviceId.touched && <FormHelperText className={classes.error}>{this.state.formControls.bacNetDeviceId.message}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="subnetMask"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.subnetMask.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="subnetMask"
                                        name="subnetMask"
                                        value={this.state.formControls.subnetMask.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.subnetMask.valid &&
                                        this.state.formControls.subnetMask.touched && <FormHelperText className={classes.error}>{this.state.formControls.subnetMask.message}</FormHelperText>}
                                </FormControl>
                            </div>
                            <div className={`${classes.inputs} ${classes.fileImportContainer2}`}>
                                <FileUploadInput
                                    accept=".gdb"
                                    fileName={this.state.fileName}
                                    upload={this.handleImport}
                                    clear={this.handleImportClear}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={classes.formColumn}>
                        <div className={classes.labelColumn}>
                            <div className={classes.advancedLabelGroup}>
                                <div className={classes.labelHeader}>
                                    <img src="/assets/images/SettingsFlat.svg" alt="settings icon" />
                                    <span>BACnet Advanced Settings</span>
                                </div>
                                <div className={classes.labelContent}>
                                    The BACnet Advanced Settings should remain at default values unless the BACnet network requires different values.
                                </div>
                            </div>
                        </div>
                        <div className={classes.inputColumn}>
                            <div className={`${classes.inputs} ${classes.advancedInputGroup}`}>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="apduTimeout"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.apduTimeout.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="apduTimeout"
                                        name="apduTimeout"
                                        value={this.state.formControls.apduTimeout.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.apduTimeout.valid &&
                                      this.state.formControls.apduTimeout.touched && <FormHelperText className={classes.error}>{this.state.formControls.apduTimeout.message}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="apduSegmentTimeout"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.apduSegmentTimeout.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="apduSegmentTimeout"
                                        name="apduSegmentTimeout"
                                        value={this.state.formControls.apduSegmentTimeout.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.apduSegmentTimeout.valid &&
                                      this.state.formControls.apduSegmentTimeout.touched && <FormHelperText className={classes.error}>{this.state.formControls.apduSegmentTimeout.message}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="apduRetries"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.apduRetries.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="apduRetries"
                                        name="apduRetries"
                                        value={this.state.formControls.apduRetries.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.apduRetries.valid &&
                                      this.state.formControls.apduRetries.touched && <FormHelperText className={classes.error}>{this.state.formControls.apduRetries.message}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="whoisTimeout"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.whoisTimeout.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="whoisTimeout"
                                        name="whoisTimeout"
                                        value={this.state.formControls.whoisTimeout.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.whoisTimeout.valid &&
                                      this.state.formControls.whoisTimeout.touched && <FormHelperText className={classes.error}>{this.state.formControls.whoisTimeout.message}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="readQueueSize"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.readQueueSize.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="readQueueSize"
                                        name="readQueueSize"
                                        value={this.state.formControls.readQueueSize.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.readQueueSize.valid &&
                                      this.state.formControls.readQueueSize.touched && <FormHelperText className={classes.error}>{this.state.formControls.readQueueSize.message}</FormHelperText>}
                                </FormControl>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.buttonContainer}>
                    <ConfirmButton
                        confirm={this.handleSave}
                        label="Save"
                        type="button"
                        disabled={!this.state.formIsValid}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isLoading: state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(BacNetEthernetPanel);
